import actionTypes from './index';

export default patch => ({ type: actionTypes.UPDATE_ADDRESS, payload: patch });
